import setFieldValue from "@iewc/Store/Handlers/CreateAccount/SetFieldValue";
import { CustomActions, CustomState } from "@iewc/Store/Reducers";
import {
    getRfqFormCheckboxBuilt,
    getRfqFormHintTextBuilt,
    getRfqFormLabelBuilt,
    OwnProps,
    requestQuoteStyles,
    setRequestFormEffects,
} from "@iewc/Widgets/CreateAccount/FormBaseComponent";
import siteMessage from "@insite/client-framework/SiteMessage";
import translate from "@insite/client-framework/Translate";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import TextField from "@insite/mobius/TextField";
import * as React from "react";
import { connect, DispatchProp, ResolveThunks } from "react-redux";

const mapStateToProps = (state: CustomState) => ({
    billingPhone: state.customCreateAccountForm.fieldValues.billingPhone,
    previouslyPurchased: state.customCreateAccountForm.fieldValues.previouslyPurchased,
});

const mapDispatchToProps = {
    setFieldValue,
};

type Props = OwnProps &
    ReturnType<typeof mapStateToProps> &
    ResolveThunks<typeof mapDispatchToProps> &
    DispatchProp<CustomActions>;

const billingPhoneRegex = /^([\(\)/\-\.\+\s]*\d\s?(ext)?[\(\)/\-\.\+\s]*){10,}$/;

const BillingPhoneWidget: React.FC<Props> = ({ previouslyPurchased, billingPhone, setFieldValue: widgetSetFieldValue }) => {
    const label = translate("Phone Number");
    const isRequired = false;
    const [fieldErrorMessage, setFieldErrorMessage] = React.useState("");

    const validatebillingPhoneNumber = () => {
        let errorMessage: any = "";
        if (!billingPhone && isRequired) {
            errorMessage = siteMessage("ContactUsForm_PhoneNumberIsRequiredErrorMessage", label);
        } else if (billingPhone && !billingPhoneRegex.test(billingPhone)) {
            errorMessage = siteMessage("ContactUsForm_PhoneNumberIsInvalidErrorMessage");
        }
        setFieldErrorMessage(errorMessage as string);
        return !errorMessage;
    };

    setRequestFormEffects(isRequired, billingPhone, "billingPhone", validatebillingPhoneNumber);

    const fieldChangeHandler = (event: React.ChangeEvent<HTMLInputElement>) => {
        widgetSetFieldValue({ key: "billingPhone", value: event.target.value });
    };

    const fieldBlurHandler = (event: React.FocusEvent<HTMLInputElement>) => {
        validatebillingPhoneNumber();
    };

    return (
        <TextField
            label={label}
            required={isRequired}
            value={billingPhone || ""}
            error={fieldErrorMessage}
            onChange={fieldChangeHandler}
            onBlur={fieldBlurHandler}
        />
    );
};

export default connect(mapStateToProps, mapDispatchToProps)(BillingPhoneWidget);
